export default __webpack_public_path__ + "static/media/pegasus_home.df550c35.jpg";